export default "__VITE_ASSET__Bb75jjh3__"